module.exports = __webpack_public_path__ + "static/media/TUNE_4530.0bd4d302.jpg";